if (
  process.env.NODE_ENV === 'production' &&
  process.env.RAZZLE_ENV !== 'preprod'
) {
  module.exports = require('./store-prod');
} else {
  module.exports = require('./store-dev');
}
